import getType from"./getType";export function isNull(payload){return getType(payload)==="Null"}export default isNull;